
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsPosShiftControlDialog extends Serenity.EntityDialog<PsPosShiftControlRow, any> {
        protected getFormKey() { return PsPosShiftControlForm.formKey; }
        protected getIdProperty() { return PsPosShiftControlRow.idProperty; }
        protected getLocalTextPrefix() { return PsPosShiftControlRow.localTextPrefix; }
        protected getNameProperty() { return PsPosShiftControlRow.nameProperty; }
        protected getService() { return PsPosShiftControlService.baseUrl; }
        protected getDeletePermission() { return PsPosShiftControlRow.deletePermission; }
        protected getInsertPermission() { return PsPosShiftControlRow.insertPermission; }
        protected getUpdatePermission() { return PsPosShiftControlRow.updatePermission; }

        protected form = new PsPosShiftControlForm(this.idPrefix);

        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();

            // if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            // }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );


            return buttons;


        }

    }
}